import React from 'react';
import { List, is } from 'immutable';
import { debounce } from 'throttle-debounce';
import { FormattedMessage } from 'react-intl';

import {
  MessagePeriodDivider,
  MessagesList,
  MessagesThread,
  NoMessages,
} from './StyledComponents';
import ChatMessage from './ChatMessage';
import CircularProgressWithBackdrop from 'components/mui/CircularProgressWithBackdrop';
import Typography from '@mui/material/Typography';

import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';

class ChatMessagesList extends React.Component {
  static flatternList(list) {
    return list ? list.toList().flatten(true) : new List();
  }

  shouldComponentUpdate(nextProps) {
    const { list } = this.props;
    if (!is(list, nextProps.list)) return true;
    return false;
  }

  componentDidUpdate(prevProps) {
    const list = this.flatList;
    const prevList = this.constructor.flatternList(prevProps.list);
    if (!prevList && list) {
      this.scrollEnd();
    }

    if (prevList && list) {
      if (!is(list.last(), prevList.last())) {
        this.scrollEnd();
      } else {
        const first = prevList.first();
        if (first) {
          this.scrollToElement(first.messageId);
        }
      }
    }
  }

  get dseq() {
    return this.props.list ? this.props.list.keySeq() : new List();
  }

  get dList() {
    return this.props.list ? this.props.list.toList() : new List();
  }

  get flatList() {
    return this.constructor.flatternList(this.props.list);
  }

  getPrevious = debounce(500, true, this.props.onPrev);

  scrollToElement(messageId) {
    const c = this.container;
    if (this.dList && c && c.children && c.children[0]) {
      this.dList.forEach((list, groupIndex) => {
        const index = list.findIndex((f) => f.messageId === messageId);
         
        if (
          index >= 0 &&
          c.children[groupIndex] &&
          c.children[groupIndex].children &&
          c.children[groupIndex].children[1] &&
          c.children[groupIndex].children[1].children[index]
        ) {
          c.children[groupIndex].children[1].children[index].scrollIntoView(true);
        }
      });
    }
  }

  scrollEnd = () => {
    const { container } = this;
    if (container) container.scrollTop = container.scrollHeight;
  };

  handleScroll = (e) => {
    const { scrollTop } = e.currentTarget;
    if (scrollTop < 5) {
      this.getPrevious();
    }
  };

  periodFormatter = (i) => {
    switch (this.dseq.get(i)) {
      case 'Yesterday':
        return <FormattedMessage id="chat.dates.yesterday" defaultMessage="Yesterday" />;
      default:
        return this.dseq.get(i);
    }
  };

  container;

  render() {
    const { list, ownerId } = this.props;

    return (
      <MessagesThread
        ref={(el) => {
          this.container = el;
        }}
        onScroll={this.handleScroll}
      >
        <MessagesList justifyContent={!this.dList.size ? 'center' : 'flex-end'}>
          {this.dList.size ? (
            this.dList.map((v, i) => (
              <section key={this.dseq.get(i)}>
                <MessagePeriodDivider textAlign="center">{this.periodFormatter(i)}</MessagePeriodDivider>

                {v.map((e) => (
                  <ChatMessage key={e.messageId} data={e} isMy={ownerId === e.sender.userId} />
                ))}
              </section>
            ))
          ) : (
            <NoMessages>
              <ChatBubbleOutlineOutlinedIcon />
              <br />
              <Typography variant="body1">
                <FormattedMessage id="chat.noMessage" defaultMessage="No messages here" />
              </Typography>
            </NoMessages>
          )}
        </MessagesList>
        {!list && <CircularProgressWithBackdrop BackdropProps={{ sx: { position: 'absolute' } }} />}
      </MessagesThread>
    );
  }
}

export default ChatMessagesList;
